import { Link } from 'react-router';
import { useContext, useEffect, useRef, useState } from 'react';

// Interne Module
import BuildInfo from '@/_helper/buildInfo';
import * as storage from '@/_helper/storage';
import globalParams from '@/_config/globalParams';
import { AppContext } from '@/context/AppContext';
import { checkTripStarts } from '@/_helper/checkTripStarts';
import useNavigationList from '@/hooks/use_navigation_list.hook';
import useOutsideClickHandler from '@/hooks/use_outside_click';
import { checkTripEnded } from '@/_helper/checkAccess';

// Komponenten
import ContactLayer from '@/comp/contactLayer';
import { Icon } from '@/comp/icon/icon';

// Styles
import './header.scss';

const Header = () => {
    const { isAffiliate, isLoggedIn, constants } = useContext(AppContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const buttonRef = useRef(null);
    const navRef = useOutsideClickHandler<HTMLUListElement>(() => setMenuOpen(false), [buttonRef]);
    const navigationList = useNavigationList();

    if (storage.get('mode') === 'app') {
        return null;
    }

    return (
        <>
            <div className="header no-print">
                <div className="outer-wrapper">
                    {window.$affiliate === 'ch24' ? (
                        <div className="logo-container">
                            <div className="affiliate-ch24--logo-ch24"></div>
                        </div>
                    ) : (
                        <Link to="/" className="logo-container">
                            <div className="aurum-logo"></div>
                        </Link>
                    )}

                    {/* get build info */}
                    <BuildInfo />

                    <div className="header-items">
                        <nav className="header-nav">
                            {isLoggedIn &&
                                process.env.VITE_ENV !== 'production' &&
                                !window.location.host.includes('aurumtours.de') &&
                                !isAffiliate && <SessionTimer />}
                            {!isAffiliate && (
                                <>
                                    {isLoggedIn && (
                                        <Link to={'/'} className="menu-item my-trip">
                                            <Icon name="explore" size={30} />
                                            <span className="title">{constants.MY_TRIP ?? 'Meine Reise'}</span>
                                        </Link>
                                    )}
                                    <ContactLayer loggedIn={isLoggedIn} />
                                    {isLoggedIn && (
                                        <Link to="/logout" className="menu-item logout">
                                            <Icon name="logout" size={30} />
                                            <span className="title">Ausloggen</span>
                                        </Link>
                                    )}
                                </>
                            )}
                        </nav>

                        {!isAffiliate && isLoggedIn && (
                            <nav className="popup-nav">
                                <button onClick={() => setMenuOpen(!menuOpen)}>
                                    <Icon
                                        size={42}
                                        className="menu-button active color-white"
                                        name={menuOpen ? 'close' : 'menu'}
                                    />
                                </button>

                                {menuOpen && (
                                    <ul className={menuOpen ? 'active' : ''} ref={navRef}>
                                        <li className="bold">
                                            <Link to="/" onClick={() => setMenuOpen(false)}>
                                                <Icon name="explore" size={30} />
                                                {constants.MY_TRIP ?? 'Meine Reise'}
                                            </Link>
                                        </li>
                                        {navigationList?.map((item, index) => (
                                            <li key={'headerNavigationItem' + index}>
                                                <Link
                                                    to={`/${item.name}`}
                                                    rel="noopener noreferrer"
                                                    onClick={() => setMenuOpen(false)}>
                                                    {item.label}
                                                </Link>
                                            </li>
                                        ))}
                                        <div className="mobile-only">
                                            <li className="bold">
                                                <a
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                    href={`${window.$website}/service/kontakt`}>
                                                    <Icon name="help" size={30} />
                                                    Kontakt
                                                </a>
                                            </li>

                                            {checkTripStarts() && !checkTripEnded() && (
                                                <li>
                                                    <a rel="noopener noreferrer" href="tel:+4989998299531">
                                                        +49 (0) 89 99 82 99 531
                                                    </a>
                                                </li>
                                            )}

                                            <li>
                                                <a
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                    href={`${window.$website}/service/kontakt`}>
                                                    Kontaktformular
                                                </a>
                                            </li>
                                            <hr />
                                            <li className="bold">
                                                <Link to="/logout">
                                                    <Icon name="logout" size={30} />
                                                    Ausloggen
                                                </Link>
                                            </li>
                                        </div>
                                    </ul>
                                )}
                            </nav>
                        )}

                        {!isAffiliate && (
                            <>{window.$browserInfo.device === 'mobile' && !isLoggedIn && <ContactLayer />}</>
                        )}
                    </div>
                </div>
            </div>
            {!isAffiliate && <>{menuOpen && <div className="menu-overlay"></div>}</>}
        </>
    );
};

const SessionTimer = () => {
    const getLogoutTime = () => {
        let autoLogoutTime = globalParams.autoLogoutTime;
        let logoutTime = autoLogoutTime - (new Date().getTime() - storage.get('login_timestamp'));

        return Math.round(logoutTime / 1000) + 's';
    };

    const [remainingTime, setRemainingTime] = useState(getLogoutTime());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setRemainingTime(getLogoutTime());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    return <div className="menu-item">Ausloggen in {remainingTime}</div>;
};
export default Header;
